module.exports = __webpack_public_path__ + "static/media/asu_logo.f1afee23.jpg";